/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device_profile_type';
import '../../../../devices/external/application_type';
import './status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "BatchDeactivateDeviceUsageBillingRequest": {
                        "fields": {
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "applicationType": {
                            "type": ".squareup.connect.v2.ApplicationType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "BatchDeactivateDeviceUsageBillingResponse": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.BatchDeactivateDeviceUsageBillingRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.BatchDeactivateDeviceUsageBillingResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchDeactivateDeviceUsageBillingRequest @ squareup/devicesettings/profiles/v2/message/batch_deactivate_device_usage_billing.proto at 13:1
 */
export const BatchDeactivateDeviceUsageBillingRequest = $root.lookupType('squareup.devicesettings.profiles.v2.message.BatchDeactivateDeviceUsageBillingRequest');
fixType(BatchDeactivateDeviceUsageBillingRequest);
Builder.createAndAttachToType(BatchDeactivateDeviceUsageBillingRequest);
/**
 * SOURCE BatchDeactivateDeviceUsageBillingResponse @ squareup/devicesettings/profiles/v2/message/batch_deactivate_device_usage_billing.proto at 22:1
 */
export const BatchDeactivateDeviceUsageBillingResponse = $root.lookupType('squareup.devicesettings.profiles.v2.message.BatchDeactivateDeviceUsageBillingResponse');
fixType(BatchDeactivateDeviceUsageBillingResponse);
Builder.createAndAttachToType(BatchDeactivateDeviceUsageBillingResponse);